// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604301533/js/" + chunkId + "." + {"44":"fe341b1d","225":"cc75c4ff","481":"8c4e595e","486":"6e89eb42","770":"a9d44a00"}[chunkId] + ".0.5598533366880394.chunk.js";
};